import { FunctionComponent } from 'react';
import { useIntl } from 'react-intl';

type BulkUpdateMaxSizeErrorMessageProps = {
    readonly totalCount?: number;
    readonly maxBulkSize: number;
    readonly identifierType: 'ORDER' | 'VEHICLE';
};

export const BulkUpdateMaxSizeErrorMessage: FunctionComponent<BulkUpdateMaxSizeErrorMessageProps> = ({
    totalCount,
    maxBulkSize,
    identifierType,
}) => {
    const { formatMessage } = useIntl();
    const messageIdPrefix =
        identifierType === 'VEHICLE'
            ? 'outboundOrderBook.compoundManagement.bulkStatusUpdate.error'
            : 'outboundOrderBook.common.bulkUpdate.error';

    return (
        <MaxSizeErrorMessage
            maxBulkSizeExceededText={formatMessage(
                { id: `${messageIdPrefix}.maxBulkSizeExceeded` },
                { count: maxBulkSize },
            )}
            maxSelectionSizeText={formatMessage({ id: `${messageIdPrefix}.maxSelectionSize` }, { count: maxBulkSize })}
            selectionSizeText={formatMessage({ id: `${messageIdPrefix}.selectionSize` })}
            totalCount={totalCount}
        />
    );
};

type MaxSizeErrorMessageProps = {
    readonly maxBulkSizeExceededText: string;
    readonly maxSelectionSizeText: string;
    readonly selectionSizeText: string;
    readonly totalCount?: number;
};

export const MaxSizeErrorMessage: FunctionComponent<MaxSizeErrorMessageProps> = ({
    maxBulkSizeExceededText,
    maxSelectionSizeText,
    selectionSizeText,
    totalCount,
}) => (
    <div className="alert alert-danger width-100pct space-y-10">
        <div className="display-flex gap-10">
            <span className="text-color-danger text-size-h4 rioglyph rioglyph rioglyph-error-sign" />
            <div>
                <strong className="text-size-16">{maxBulkSizeExceededText}</strong> {maxSelectionSizeText}{' '}
                {totalCount !== undefined && (
                    <span>
                        {selectionSizeText} {totalCount}
                    </span>
                )}
            </div>
        </div>
    </div>
);
